import { reactive, ref } from 'vue'
import { defineStore } from 'pinia'
import {
  sendAiMessage,
  chatInit,
  getChatMessage,
  // getFastCommandList,
  getGuessYouWant,
  stopMessageChat,
  apiQueryUserLastDealRegion
} from '@/api/chat'
import { queryDictOptions } from '@/api/common'
import { queryRegion } from '@/api/goapi'
import { getUuid } from '@/utils'
// import { useIM } from '@/hooks/event/useIM'
import { DEFAULT_USER_AVATAR } from '@/constants'
import { showToast } from 'vant'
import { formatDate } from '@/utils/tools'
import sensors from '@/utils/sa-sdk-javascript'

export const useChatStore = defineStore('chat', () => {
  // const im = useIM()
  const messageList = ref<Message[]>([])
  const isExistHistoryChat = ref(false) // 是否存在聊天历史
  const minMessageId = ref<number | null>(0) // 最早消息id
  const currentChatList = ref<Message[]>([]) // 当日聊天记录

  const initChatData = ref<InitChatData | null>()
  const initUserData = ref<Chat>({})

  const isShowDaozhen = ref<boolean>(false) // 是否正在进行AI导诊
  const isShowDeepAsk = ref<boolean>(false) // 是否正在进行症状自查
  const isShowDeepThink = ref<boolean>(false) // 是否正在进行深度思考
  const exitFlowIng = ref<boolean>(false) // 是否正在退出中

  const sessionNum = ref<number | null>(null) // 流程进度-当前第几步
  const totalSessionNum = ref<number | null>(null) // 流程进度-一共几步

  let mySSE: any = null

  // 当前对话id
  const dialogue_id = ref<number | null>(null)

  // 如果有ext字段，判断ext_type是person_questionnaire，遍历questionnaires，判断option_type为text，将answers改为['']
  const dealExt = enterExt => {
    if (!enterExt) {
      return enterExt
    }

    for (const aE of enterExt) {
      if (aE.ext_type === 'person_questionnaire' && aE?.questionnaires?.questionnaires?.length) {
        for (const aQ of aE.questionnaires.questionnaires) {
          if (aQ.option_type === 'text' && (!aQ.answers || aQ.answers.length === 0)) {
            aQ.answers = aQ.answers || ['']
          }
        }
      }
    }

    return enterExt
  }

  // AI的信息
  const robot = reactive<Robot>({
    chat_id: null,
    command_list: [],
    is_sending: false // 是否在发送中
  })

  // 手动退出问答流程
  const fnExitFlowByUser = res => {
    if (isShowDaozhen.value || isShowDeepAsk.value || isShowDeepThink.value) {
      const msgIndex = messageList.value.length - 1

      messageList.value[msgIndex].sign_rec = res.data.sign_rec
      messageList.value[msgIndex].sign_rec_content = res.data.sign_rec_content
      isShowDaozhen.value = false
      isShowDeepAsk.value = false
      isShowDeepThink.value = false
      sessionNum.value = null
      totalSessionNum.value = null
      exitFlowIng.value = false
    }
  }

  // 患者列表
  const userPatients = ref<UserPatients[]>([])
  // 当前患者
  const currentUserPatient = ref<UserPatients | null>(null)
  // 切换当前患者
  const fnChangeCurrentUserPatient = async (newVal: UserPatients) => {
    currentUserPatient.value = newVal
    initUserData.value.patient_uid = newVal.patient_uid // 重新start，需要把患者id传给后端

    exitFlowIng.value = true
    const res = await chatInit(initUserData.value)
    exitFlowIng.value = false

    // 此处通知后端切换患者id了
    try {
      if (res.status === '0') {
        // 顺便更新下chat_id
        robot.chat_id = res.data?.chat_id || robot.chat_id

        fnExitFlowByUser(res)
      }
    } catch (err) {
      console.log(err)
    }
  }

  // 退出导诊流程
  const fnExitFlow = async () => {
    exitFlowIng.value = true
    const res = await chatInit(Object.assign({}, initUserData.value, { open_scene: 5 }))
    exitFlowIng.value = false
    try {
      if (res.status === '0') {
        fnExitFlowByUser(res)
      }
    } catch (err) {
      console.log(err)
    }
  }

  // 查询用户所在区域
  const queryUserLastDealRegion = async params => {
    const res = await apiQueryUserLastDealRegion(params)

    try {
      if (res.status === '0') {
        return res?.data?.region_id || ''
      }
    } catch (err) {
      console.log(err)
    }
  }

  // 创建对话
  const createChat = async (chatData: Chat) => {
    if (mySSE) {
      mySSE.abort()
      mySSE = null
    }

    initUserData.value = chatData
    messageList.value = []
    // 重置聊天记录是否加载完成的状态
    chatMessageLoadCompleted.value = false
    sendLock.value = false
    dialogue_id.value = null

    const res = await chatInit(chatData)
    try {
      if (res.status === '0') {
        const chatInitData = res.data || {}

        initChatData.value = { ...chatInitData }

        robot.chat_id = chatInitData.chat_id
        isExistHistoryChat.value = chatInitData.is_exist_history_chat || false
        minMessageId.value = chatInitData.min_message_id || null
        currentChatList.value = (chatInitData.current_chat_list || []).map(item => {
          item.ext = item.ext ? dealExt(JSON.parse(item.ext)) : null
          item.uid = getUuid(32)

          return item
        })

        if (currentChatList.value.length) {
          messageList.value = currentChatList.value.map(item => {
            return {
              id: item.id,
              uid: item.uid,
              message_type: item.message_type,
              direction: item.direction,
              scene: item.scene,
              content: (item.thinking_content ? `## 思考过程\n${item.thinking_content}\n## 思考结果\n` : '') + item.content,
              ext: item.ext,
              send_at: item.send_at,
              intent_type: item.intent_type,
              voteType: item.voteType,
              sign_rec: item.sign_rec,
              sign_rec_content: item.sign_rec_content,
              if_deepask: item.if_deepask,
              if_deepthink: item.if_deepthink,
              loading: false,
              avatar: item.direction == 1 ? DEFAULT_USER_AVATAR : '/robot_avatar.png',
              guess_you_want: []
            }
          })
        }

        const welcomeCardItem: Message = {
          id: -1,
          uid: 'welcomeCardItem',
          message_type: -1, // 欢迎组件
          direction: 2,
          scene: -1,
          content: '',
          send_at: '',
          loading: false,
          ext: null,
          avatar: '',
          guess_you_want: []
        }

        const historyCardItem: Message = {
          id: -2,
          uid: 'welcomeCardItem',
          message_type: -2, // 下拉查看历史记录标志组件
          direction: 2,
          scene: -2,
          content: '',
          send_at: '',
          loading: false,
          ext: null,
          avatar: '',
          guess_you_want: []
        }

        messageList.value.unshift(welcomeCardItem)

        // 患者列表
        userPatients.value = chatInitData.user_patients ?? []
        // 当前患者
        currentUserPatient.value = userPatients.value.find(item => item.default_flag === 1) || (userPatients.value.length ? userPatients.value[0] : null)

        // 如果存在历史聊天记录，插入历史聊天记录提示语
        if (chatInitData.is_exist_history_chat) {
          messageList.value.unshift(historyCardItem)
        }
      } else {
        showToast(res.message)
      }

      // // 插入欢迎语
      // insertWelcomeMsg(res.data.message)

      // 连接im
      // im.connect('M123456')
      // im.on('message', onImMessage)

      return res
    } catch (e) {
      Promise.reject(e)
    }
  }

  const updateRecommondList = async (chatData: Chat) => {
    const res = await chatInit(
      Object.assign(chatData, {
        open_scene: 4
      })
    )
    try {
      if (res.status === '0') {
        const chatInitData = res.data || {}

        if (initChatData.value?.recommended_questions) {
          initChatData.value.recommended_questions = { ...chatInitData.recommended_questions }
        }
      }
      return res
    } catch (e) {
      Promise.reject(e)
    }
  }

  // 插入来自im的聊天记录
  /*const onImMessage = (msg: Message) => {
    if (import.meta.env.DEV) {
      msg.dialogue_id = dialogue_id.value
    }
    if (msg && msg.dialogue_id == dialogue_id.value) {
      msg.uid = getUuid(32)
      msg.loading = false

      messageList.value.push(msg)
    }
  }*/

  // //  插入欢迎语
  // const insertWelcomeMsg = (msg: Message) => {
  //   if (msg) {
  //     msg.uid = getUuid(32)
  //     msg.loading = false

  //     messageList.value.push(msg)
  //   }
  // }

  // 推送用户的消息到列表
  const pushUserMessage = (msg: Message) => {
    messageList.value.push(msg)
  }

  const pushAiMessage = (msg: Message) => {
    messageList.value.push(msg)
  }

  // 更新AI的消息到列表
  const updateAiMessage = (type: string, data: any, uid: string) => {
    const resData = JSON.parse(data)
    const msgIndex = messageList.value.findIndex(item => item.uid == uid)

    if (type === 'major') {
      messageList.value[msgIndex].id = resData.ai_message_id
    } else if (type === 'intent') {
      messageList.value[msgIndex].intent_type = resData.intent_type // 更新意图

      // 和问答流程相关的不显示3个问题
      if (resData.intent_type === 101 && !isShowDaozhen.value && !isShowDeepAsk.value && !isShowDeepThink.value && messageList.value[msgIndex].if_deepask !== 5) {
        messageList.value[msgIndex].getGuessYouWantFlag = true
      }
    } else if (type === 'tips') {
      // 更新问答流程进入/离开以及提示语
      messageList.value[msgIndex].sign_rec = resData.sign_rec
      messageList.value[msgIndex].sign_rec_content = resData.sign_rec_content
      messageList.value[msgIndex].if_deepask = resData.if_deepask
      messageList.value[msgIndex].if_deepthink = resData.if_deepthink

      if (import.meta.env.VITE_APP_ENV === 'production') {
        // 智能问诊进入埋点
        if (resData.if_deepask === 1 || resData.if_deepask === 2) {
          sensors.track('hz_ai_deep_think_enter', {
            if_deepask: resData.if_deepask
          })
        }

        // 智能问诊深度思考输出埋点
        if (resData.if_deepask === 5) {
          sensors.track('hz_ai_deep_think_output', {})
        }

        // 深度思考进入/回复埋点
        if (resData.if_deepthink === 1 || resData.if_deepthink === 2) {
          sensors.track('hz_ai_true_deep_answer', {
            if_deepthink: resData.if_deepthink
          })
        }
      }

      if (resData.sign_rec === 1) {
        // 进入问答流程
        if (resData.if_deepthink === 1) {
          // 深度思考
          isShowDeepAsk.value = false
          isShowDaozhen.value = false
          isShowDeepThink.value = true
        } else if (resData.if_deepask === 1 || resData.if_deepask === 2) {
          // 症状自查
          isShowDeepAsk.value = true
          isShowDaozhen.value = false
          isShowDeepThink.value = false
        } else {
          // 智能导诊
          isShowDeepAsk.value = false
          isShowDaozhen.value = true
          isShowDeepThink.value = false
        }
        exitFlowIng.value = false
      } else if (resData.sign_rec === 3) {
        // 退出问答流程
        isShowDaozhen.value = false
        isShowDeepAsk.value = false
        isShowDeepThink.value = false
        exitFlowIng.value = false
      }

      // 进入问答流程显示问答流程进度(深度思考R1没有进度)
      if ((isShowDaozhen.value || isShowDeepAsk.value) && resData.session_num && resData.total_session_num) {
        sessionNum.value = resData.session_num
        totalSessionNum.value = resData.total_session_num
      } else {
        sessionNum.value = null
        totalSessionNum.value = null
      }
    } else if (type === 'message') {
      const oldText = messageList.value[msgIndex].content

      messageList.value[msgIndex].content = oldText + resData.content
      messageList.value[msgIndex].status = 'typing'
    } else if (type === 'complete') {
      messageList.value[msgIndex].ext = resData.ext ? dealExt(JSON.parse(resData.ext)) : null
      messageList.value[msgIndex].status = 'stop'
      if (messageList.value[msgIndex].getGuessYouWantFlag) {
        onGetGuessYouWant(uid)
      }
    }
  }

  // 更新用户的消息到列表
  const updateUserMessage = (uid: string, id: number) => {
    const msgIndex = messageList.value.findIndex(item => item.uid == uid)

    messageList.value[msgIndex].id = id
  }

  // 更新AI消息到列表
  const updateAIMessageParams = (id: number | null, params: any) => {
    const msgIndex = messageList.value.findIndex(item => item.id == id)

    for (const [key, value] of Object.entries(params)) {
      messageList.value[msgIndex][key] = value
    }
  }

  // 关闭AI的消息加载状态
  const closeAiMessageLoading = () => {
    const msgIndex = messageList.value.length - 1

    messageList.value[msgIndex].loading = false
    messageList.value[msgIndex].status = 'stop'
  }

  // 发送消息
  const sendLock = ref(false)

  const sendMessage = (userInputContent: UserInputContent) => {
    if (sendLock.value) {
      return
    }

    const userMsg: Message = {
      id: null,
      uid: getUuid(32),
      message_type: 1,
      direction: 1,
      scene: 1,
      content: userInputContent.content,
      ext: null,
      send_at: '',
      loading: false,
      avatar: DEFAULT_USER_AVATAR,
      guess_you_want: []
    }
    const aiMsg: Message = {
      id: null,
      uid: getUuid(32),
      message_type: 1,
      direction: 2,
      scene: 4,
      content: '',
      ext: null,
      send_at: '',
      loading: true,
      avatar: '/robot_avatar.png',
      guess_you_want: [],
      sign_rec: 0,
      sign_rec_content: '',
      if_deepask: 0,
      if_deepthink: 0
    }
    const params: any = {
      user_reply: userInputContent.content,
      chat_id: robot.chat_id,
      parent_message_id: dialogue_id.value,
      recommend_id: userInputContent.recommend_id || null
    }

    // 切换城市传参
    if (userInputContent.region_id) {
      params.from_date = userInputContent.from_date
      params.to_date = userInputContent.to_date
      if (userInputContent.clinic_ids) {
        params.clinic_ids = userInputContent.clinic_ids
      }
      params.region_id = userInputContent.region_id

      aiMsg.from_date = userInputContent.from_date
      aiMsg.to_date = userInputContent.to_date
      aiMsg.clinic_ids = userInputContent.clinic_ids
      aiMsg.region_id = userInputContent.region_id
      aiMsg.region_name = userInputContent.region_name
    }

    // 问答流程传参
    if (userInputContent.if_guide) {
      params.if_guide = userInputContent.if_guide
    }
    if (userInputContent.if_deepask) {
      params.if_deepask = userInputContent.if_deepask
    } else if (isShowDeepAsk.value) {
      params.if_deepask = 3
    }
    if (userInputContent.if_deepthink) {
      params.if_deepthink = userInputContent.if_deepthink
    } else if (isShowDeepThink.value) {
      params.if_deepthink = 2
    }

    // 问卷传参
    if (userInputContent.person_questionnaire) {
      params.person_questionnaire = userInputContent.person_questionnaire
      params.person_questionnaire_message_id = userInputContent.person_questionnaire_message_id
    }

    // 插入用户的问题到聊天记录
    if (userMsg.content) {
      pushUserMessage(userMsg)
    }
    // 插入AI的回答到聊天记录
    pushAiMessage(aiMsg)

    sendLock.value = true
    mySSE = sendAiMessage(params)
    mySSE.onMessage = res => {
      if (import.meta.env.MODE !== 'production') {
        console.log(res)
      }
      robot.is_sending = true

      if (res.event === 'major') {
        const resData = JSON.parse(res.data)

        // 更新当前对话id
        dialogue_id.value = resData.ai_message_id
        if (userMsg.content) {
          // 更新用户会话id
          updateUserMessage(userMsg.uid, resData.user_message_id)
        }
        // 更新AI会话id
        updateAiMessage('major', res.data, aiMsg.uid)

        // 去掉其他消息的猜你想问
        messageList.value = messageList.value.map(item => {
          return {
            ...item,
            guess_you_want: []
          }
        })
      } else {
        updateAiMessage(res.event, res.data, aiMsg.uid)

        if (res.event === 'complete') {
          robot.is_sending = false
        }
      }
    }
    mySSE.onAbort = () => {
      console.log('------onAbort------------')
    }
    mySSE.onClose = () => {
      console.log('------onClose------------')
      mySSEClose()
    }
    mySSE.onError = () => {
      showToast('测试环境响应超时，请重新输入你的问题')

      // 把最后一条机器人消息干掉
      messageList.value.splice(messageList.value.length - 1, 1)

      dialogue_id.value = messageList.value.length ? messageList.value[messageList.value.length - 1].id : null
      sendLock.value = false // 是否正在发送消息
    }
  }

  const mySSEClose = () => {
    closeAiMessageLoading()
    sendLock.value = false
    mySSE = null
  }

  const stopGetMessage = () => {
    // mySSE.abort()
    const reqData = {
      chat_id: robot.chat_id,
      message_id: dialogue_id.value
    }
    stopMessageChat(reqData)
    // 给最后一条消息添加手动停止回答的标识
    messageList.value[messageList.value.length - 1].manualStopFlag = true

    // mySSEClose()
  }

  // 健康咨询101-获取三个问题
  const GuessYouWantPageSize = 3
  const isLoadingGuessYouWant = ref(false) // 是否正在加载猜你想问，用于动画loading效果

  const onGetGuessYouWant = (uid: string) => {
    isLoadingGuessYouWant.value = true
    getGuessYouWant({
      chat_id: robot.chat_id,
      size: GuessYouWantPageSize
    })
      .then(res => {
        if (res.status === '0') {
          const msgIndex = messageList.value.findIndex(item => item.uid == uid)

          // 猜你想问接口可能会慢，此处判断这条消息还是最后一条才处理
          if (msgIndex === messageList.value.length - 1) {
            messageList.value[msgIndex].guess_you_want = res.data || []
          }
        }
      })
      .finally(() => {
        isLoadingGuessYouWant.value = false
      })
  }

  // 获取聊天记录
  const chatMessagePageSize = 10
  const chatMessageLoadCompleted = ref(false)

  const onGetChatMessage = async () => {
    if (chatMessageLoadCompleted.value) {
      return
    }

    const list = messageList.value.filter(item => item.uid !== 'welcomeCardItem')

    minMessageId.value = list.length > 0 ? list[0].id : null

    const params = {
      chat_id: robot.chat_id,
      min_message_id: minMessageId.value,
      size: chatMessagePageSize
    }

    const res = await getChatMessage(params)

    try {
      if (res.status === '0') {
        const list = res.data.chat_list || []
        let dealedList = []

        // 消息加载完了
        if (list.length === 0) {
          chatMessageLoadCompleted.value = true
          return
        }
        dealedList = list.map(item => {
          return {
            id: item.id,
            uid: getUuid(32),
            message_type: item.message_type,
            direction: item.direction,
            content: (item.thinking_content ? `## 思考过程\n${item.thinking_content}\n## 思考结果\n` : '') + item.content,
            ext: item.ext ? dealExt(JSON.parse(item.ext)) : null,
            send_at: item.send_at,
            intent_type: item.intent_type,
            voteType: item.voteType,
            sign_rec: item.sign_rec,
            sign_rec_content: item.sign_rec_content,
            if_deepask: item.if_deepask,
            if_deepthink: item.if_deepthink,
            loading: false,
            avatar: item.direction == 1 ? DEFAULT_USER_AVATAR : '/robot_avatar.png',
            guess_you_want: []
          }
        })

        const _tmp = [...dealedList, ...messageList.value]
        let preDate = 0
        const newArr = _tmp.map((item, index) => {
          let showTimeFlag = false
          if (item.send_at) {
            if (index === 0) {
              showTimeFlag = true
            } else if (new Date(item.send_at).getDate() !== preDate) {
              showTimeFlag = true
            }
          }

          if (showTimeFlag) {
            preDate = new Date(item.send_at).getDate()
            item.showTimeDate = formatDate(item.send_at, 'yyyy-MM-dd')
          }

          return item
        })

        messageList.value = [...newArr]
      } else {
        showToast(res.message)
      }

      return res
    } catch (err) {
      Promise.reject(err)
    }
  }

  // const getFastCommand = () => {
  //   getFastCommandList({
  //     chat_id: robot.chat_id,
  //   }).then(res => {
  //     robot.command_list = res.data;
  //   })
  // }

  // const updataQuickComand = (data) => {
  //  // 更新快捷指令
  //   robot.command_list = data.comand_list || [];
  // }

  function $reset() {
    // 关闭im
    // im.close()

    dialogue_id.value = null
    messageList.value = []
    robot.chat_id = null // 会话id
    chatMessageLoadCompleted.value = false // 消息是否加载完了
    sendLock.value = false // 是否正在发送消息
  }

  // 获取城市列表
  const regionList = ref<any[]>([])
  const fnQueryRegion = (isShowFailToast, fnCb) => {
    queryRegion({
      gst: 1,
      page_no: 1,
      page_size: 999
    }).then(res => {
      if (res.code === 200) {
        regionList.value = res.data || []
        if (fnCb) fnCb()
      } else {
        if (isShowFailToast) {
          showToast('获取城市列表失败')
        }
      }
    })
  }

  // 获取点踩的选项
  const feedbackCaiOptions = ref<null | HTMLDivElement>(null)
  const fnQueryFeedbackCaiOptions = isShowFailToast => {
    queryDictOptions({
      dictGroup: 'message_vote'
    }).then(res => {
      if (res.status === '0') {
        feedbackCaiOptions.value = res.data || []
      } else {
        if (isShowFailToast) {
          showToast(res.message || '获取点踩选项失败')
        }
      }
    })
  }

  return {
    $reset,
    robot,
    initUserData,
    dialogue_id,
    sendLock,
    messageList,
    isExistHistoryChat,
    minMessageId,
    currentChatList,
    userPatients,
    currentUserPatient,
    fnChangeCurrentUserPatient,
    fnExitFlow,
    queryUserLastDealRegion,
    createChat,
    updateRecommondList,
    sendMessage,
    onGetChatMessage,
    stopGetMessage,
    initChatData,
    isLoadingGuessYouWant,
    regionList,
    fnQueryRegion,
    feedbackCaiOptions,
    fnQueryFeedbackCaiOptions,
    updateAIMessageParams,
    isShowDaozhen,
    isShowDeepAsk,
    isShowDeepThink,
    exitFlowIng,
    sessionNum,
    totalSessionNum
    // getFastCommand,
    // updataQuickComand,
  }
})
